import type { CreateTeamPayload, Team, UpdateTeamPayload } from "@/schema"

import { ApiContext, apiContextFetch } from "@/hooks/api/base"

export function fetchTeams(context: ApiContext): Promise<{ teams: Team[] }> {
  return apiContextFetch<{ teams: Team[] }>(context, "teams")
}

export function fetchCompanyTeams(context: ApiContext): Promise<{ teams: Team[] }> {
  return apiContextFetch<{ teams: Team[] }>(context, "teams/company_index")
}

export function createTeam(context: ApiContext, payload: CreateTeamPayload): Promise<Team> {
  return apiContextFetch<Team>(context, "teams", {
    method: "POST",
    body: JSON.stringify({ team: payload }),
  })
}

export function updateTeam(context: ApiContext, id: string, payload: UpdateTeamPayload): Promise<Team> {
  return apiContextFetch<Team>(context, `teams/${id}`, {
    method: "PATCH",
    body: JSON.stringify({ team: payload }),
  })
}

export function destroyTeam(context: ApiContext, id: string): Promise<void> {
  return apiContextFetch<void>(context, `teams/${id}`, {
    method: "DELETE",
  })
}
